var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcEditGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15415_21859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.36283 3.225H3.21744C2.60033 3.225 2.1001 3.72523 2.1001 4.34234V13.2811C2.1001 13.8982 2.60033 14.3984 3.21744 14.3984H12.1562C12.7733 14.3984 13.2735 13.8982 13.2735 13.2811V7.1357",
    stroke: "#9e9e9e",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4003 2.67886L9.0797 8.99947L7.10449 9.39453L7.49953 7.41932L13.8202 1.09869C14.0383 0.880528 14.3921 0.880528 14.6102 1.09869L15.4003 1.88879C15.6185 2.10695 15.6185 2.46067 15.4003 2.67886Z",
    stroke: "#9e9e9e",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0303 1.88859L14.6104 3.46875",
    stroke: "#9e9e9e",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15415_21859"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEditGray);
export default __webpack_public_path__ + "static/media/ic-edit-gray.3d41625251e7fb5275945d0a44372fce.svg";
export { ForwardRef as ReactComponent };